<template>
  <FriedModalSubContainer :class="['sign-confirm', { 'no-border-radius': hideBorderRadius }]">
    <div class="sign-confirm-container" data-external="signing-page-sign-confirmation-container">
      <Animation
        class="sign-confirm-logo"
        :name="'logo_green'"
        :loop="false"
        @created="handleAnimationLoaded"
      ></Animation>
      <div class="modal-header">
        <h2 class="modal-title">{{ $t('document-successfully-signed!') }}</h2>
      </div>
      <div class="modal-content">
        <h5 class="signed-explanation">
          {{ $t('you-will-recive-a-copy-of-the-signed-document') }}
        </h5>
      </div>
    </div>
    <div v-if="shouldPopStripe" class="stripe-loading">
      <FriedSpinner current-color :size="24" />
      <FriedH4>{{ $t('loading-payment-modal') }}</FriedH4>
    </div>
  </FriedModalSubContainer>
</template>

<script lang="ts">
import Animation from '@getaccept/lib-shared-new/src/components/Animation.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {
    Animation,
  },
  props: {
    hideBorderRadius: {
      type: Boolean,
      default: false,
    },
    shouldPopStripe: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const animationDelay = 1000;

    const handleAnimationLoaded = (animation: any) => {
      setTimeout(() => {
        animation.play();
      }, animationDelay);
    };

    return {
      handleAnimationLoaded,
    };
  },
});
</script>

<style lang="scss" scoped>
$logo-height: 64px;

.sign-confirm {
  border-radius: var(--radius-medium);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  &.no-border-radius {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  @media screen and (max-width: $sm) {
    padding: 0 var(--spacing-50);
  }
  @media only screen and (max-width: $xs), (max-height: $xs) and (orientation: landscape) {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  .sign-confirm-container {
    padding: var(--spacing-100) var(--spacing-200);

    .sign-confirm-logo {
      height: $logo-height;
    }

    .modal-header {
      background-color: transparent;
      margin-top: var(--spacing-50);
      height: fit-content;
      text-transform: none;

      .modal-title {
        color: var(--text-dark);
        margin: 0;
        line-height: initial;
        text-align: center;
      }
    }

    .modal-content {
      padding: 0;
      padding-top: $spacing-100;
      text-align: center;
      flex-direction: column;
      height: fit-content;

      .signed-explanation {
        line-height: inherit;
        font-weight: 400;
        margin: 0;
      }
    }
  }
}

.stripe-loading {
  display: flex;
  color: var(--text-white);
  width: 100%;
  justify-content: center;
  gap: var(--spacing-100);
  align-items: center;
  padding-bottom: var(--spacing-200);

  .loader-circular {
    width: auto;
  }

  .heading-4 {
    color: var(--text-white);
  }
}
</style>
